// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2wHj1","messages":"Chat_messages__2cikx","dateDivider":"Chat_dateDivider__1DLcs"};